export default function() {
  $(document).ready(function() {
    window.thinkwell.lib.inject('/account', '/accounts/orders', '#customer-account', {replaceWith: true, withoutLoader: true});
  });
}
